import React from 'react';

import { Plus as AddOutlined } from "lucide-react";
import { Box, ButtonBase } from '@mui/material';

type Props = {
  onClick: () => void;
};
export default function PlaceholderButton({ onClick }: Props) {
  return (
    <ButtonBase
      onClick={(ev) => {
        ev.stopPropagation();
        onClick();
      }}
      sx={{
        display: 'flex',
        alignContent: 'center',
        justifyContent: 'center',
        height: 48,
        width: '100%',
        bgcolor: 'rgba(0,0,0, 0.05)',
      }}
    >
      {/* Was styled with MUI palette paths in a plain `style`, which CSS ignores --
          the plus rendered unstyled. Uses the theme's own colours now. */}
      <Box
        sx={{
          display: 'flex',
          p: 0.5,
          borderRadius: '50%',
          bgcolor: 'primary.main',
          color: 'primary.contrastText',
        }}
      >
        <AddOutlined className="size-4" />
      </Box>
    </ButtonBase>
  );
}
